<template>
  <div class="contractors-tender-card pointer" @click="goToTender">
    <div class="contractors-tender-card__project-title">
      {{ tender.project_name }}
    </div>
    <div class="contractors-tender-card__tender-title">
      {{ tender.tender_name }}
    </div>
    <Badge class="contractors-tender-card__status" contrast :color="badgeColor">
      <span class="capitalize">{{ badgeText }}</span>
    </Badge>
    <div class="contractors-tender-card__dates">
      <div>{{ $t('Last offered') }}: {{ prettyDates(tender.updated_at) }}</div>
      <div>{{ $t('Submission deadline') }}: {{ prettyDates(tender.offers_deadline_date) }}</div>
    </div>
  </div>
</template>

<script>
  import prettyDates from '@/utils/formatting/pretty-date';
  import TENDER_OFFER_STATUS_BADGE from '@/utils/constants/tender-offer-status-badge';
  import Badge from '@/components/ui/Badge';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'ContractorsTenderCard',
    components: { Badge },
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['tenderOfferStatuses']),
      badgeText() {
        const count = this.tender.submitted_versions_count;
        return this.tender.status === 'offered'
          ? this.$tc('offer', count)
          : this.tenderOfferStatuses[this.tender.status];
      },
      badgeColor() {
        return TENDER_OFFER_STATUS_BADGE[this.tender.status];
      },
    },
    methods: {
      ...mapActions({
        closeModal: 'modal/closeModal',
      }),
      prettyDates,
      goToTender() {
        this.closeModal();
        this.$router.push({
          name: 'tender-info',
          params: {
            tenderId: this.tender.tender_id,
            id: this.tender.project_id,
          },
        });
      },
    },
  };
</script>
